import { EXPRESS_API } from 'configs/api/expressApi';
import { useQuery } from 'react-query';
import { videoRequestKeys } from './videoRequestKeys';

export interface IVideoRequestByVideoId {
  videoRequestId: number;
  userId: number;
  advisorId: number;
  customerId: number;
  videoId: number;
  videoType: string;
  repairOrderNumber: string;
  vin: null;
  automotiveDepartment: number;
  sharedWithCompany: boolean;
  note: null;
  deniedNote: null;
  customerName: string;
  status: string;
  emailStatus: string;
  createdAt: Date;
  deletedAt: null;
}

const getVideoRequestByVideoId = async (videoId: string | number) => {
  const response = await EXPRESS_API.get(
    `/video-requests/${videoId}/get-by-videoid`
  );
  return response.data as IVideoRequestByVideoId;
};

export const useVideoRequestByVideoIdQuery = (
  videoId: string | number,
  enabled: boolean
) => {
  return useQuery(
    videoRequestKeys.single_by_video_id(videoId),
    () => getVideoRequestByVideoId(videoId),
    {
      enabled: !!videoId && enabled,
      refetchOnMount: true,
    }
  );
};
